import React, { lazy, Suspense } from 'react'
import { observer } from 'mobx-react'
import { observable, reaction } from 'mobx'
import {
  customerContainer,
  accountsContainer,
  accountsAddressContainer,
  addressContainer,
  storeContainer,
} from 'src/models'
import { AddressValidation, toastState } from 'src/views/components'
import {
  parsePhoneNumberField,
  validLibMobilePhoneNumber,
  getReadOnlyFields,
} from 'src/utils/signUpUtils'
import { Button, Row, Col, Card, Modal, Alert } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { AccountProfilePIIForm } from './UserPIIForm/AccountProfilePIIForm'
import { ChangeAccountTypeCard } from './ChangeAccountType/ChangeAccountTypeCard'
import { AccountProfileFormContext } from './context'
import {
  application,
  getLocaleCodeFromUrl,
  getLocalStorage,
  isB2B2CAdmin,
  trackGTMEvents,
} from 'src/utils'
import {
  getAddressFieldsJsonBasedOnCountry,
  getAddressOnlyFieldsForValidation,
  checkIfFormIsEmpty,
  checkIfTwoFormValuesAreEqual,
} from 'src/deps'
import { APPConfig, IS_BROWSER } from 'config/appConfig'
import './styles.scss'

@observer
class AccountFormIntlShipping extends React.Component {
  @observable combinedFormData = {
    addressData: {},
    PIIData: {},
  }
  @observable AddressFormRef = React.createRef()
  @observable AccountPIIFormRef = React.createRef()

  @observable showPopup = false
  @observable addressFormValid = false
  @observable accountPIIFormValid = false
  @observable addressInvalidFlag = false
  @observable recommendations = []
  @observable popupFormData = {}
  @observable formData = {}
  @observable nonValidAddress = false
  @observable show = false
  getlocal = getLocaleCodeFromUrl({
    defaultLocale: 'en_US',
    isReverseType: true,
  })
  country = this.getlocal?.split('_').length ? this.getlocal?.split('_')[1] : ''
  addressDisable = getReadOnlyFields('addressReadOnly', this.country)

  static contextType = AccountProfileFormContext

  FORM = 'FORM'
  POPUP = 'POPUP'
  SUBMIT_BUTTON = 'SUBMIT_BUTTON'

  AddressForm = ''
  currentMarket = storeContainer?.defaultShippingRegion
    ? 'Address' + storeContainer?.defaultShippingRegion
    : 'AddressUS'
  AddressForm = lazy(
    () =>
      import(
        'src/views/addresses/' + this.currentMarket + '/' + this.currentMarket
      )
  )

  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const reactions = reaction(
      () => [this.addressFormValid, this.accountPIIFormValid],
      values => {
        if (values[0] && values[1]) {
          this.makeAPIsIfAllThreeFormsAreValid()
        }
      }
    )
    trackGTMEvents({
      event: 'nuskin-profile',
      eventType: 'Profile-Account',
    })
  }

  makeAPIsIfAllThreeFormsAreValid = async () => {
    this.formData = {
      ...this.combinedFormData.addressData,
      ...this.combinedFormData.PIIData,
      ...this.combinedFormData.accTypeData,
    }
    const {
      businessEmail = '',
      email = '',
      postalCode = '',
      zip = '',
      mobilePhoneNumber = '',
      businessPhoneNumber = '',
      stateList = '',
      state = '',
      wardList = '',
      city = '',
      county = '',
      districtList = '',
      district = '',
      phoneCountryCode = '',
      firstName = '',
      lastName = '',
      country = '',
      ...remainingProps
    } = this.formData || {}

    accountsAddressContainer.isAccountAddressEmpty = false

    const newEmail = businessEmail || email
    const exEmail = customerContainer.profileResponse?.email || ''

    //Parsing Phone Number...
    const phoneNumber = mobilePhoneNumber || businessPhoneNumber
    const phoneObj =
      (await parsePhoneNumberField(phoneNumber, phoneCountryCode)) || {}

    const phone = phoneObj?.number || ''

    if (this.addressDisable) {
      delete remainingProps.phone
    }
    let addressValidData = {
      phone,
      type: 'Local',
      zip: postalCode?.toUpperCase() || zip,
      email,
      state: stateList || state,
      city: wardList || city,
      county: county || districtList || district,
      country: country || storeContainer?.defaultShippingRegion,
      homeCountry: country || '',
      phoneCountryCode,
      businessEmail,
      firstName: firstName?.trim(),
      lastName: lastName?.trim(),
      ...remainingProps,
    }

    this.formData.zip = postalCode?.toUpperCase() || zip
    this.formData.state = stateList || state
    this.formData.city = wardList || city
    this.formData.county = county || districtList || district
    this.formData.country = country || storeContainer?.defaultShippingRegion

    delete this.formData?.postalCode
    delete this.formData?.stateList

    const acctype = getLocalStorage('accountType')

    if (this.showPopup === true) {
      this.showPopup = false

      this.handleCondition(this.popupFormData)
    } else {
      if (
        newEmail === exEmail ||
        acctype === 'Brand Affiliate - Business Entity'
      ) {
        this.handleCondition(addressValidData)
      } else if (acctype !== 'Brand Affiliate - Business Entity') {
        this.popupFormData = { ...addressValidData }

        this.showPopup = true
      } else {
        await accountsAddressContainer.updateAccountAddress(this.formData)
        await customerContainer.updateForAccountProfile(this.formData)
      }
    }
  }

  getFormFieldsBasedOnCountry = async () => {
    let fieldJson = await getAddressFieldsJsonBasedOnCountry(this.country)
    let formFields = await getAddressOnlyFieldsForValidation(
      fieldJson,
      'accountProfile'
    )
    return formFields
  }

  checkIfFormFieldsAreEmpty = async (formData = {}) => {
    let formFields = await this.getFormFieldsBasedOnCountry()
    let isFormFieldEmpty =
      (await checkIfFormIsEmpty(formFields, formData)) || false
    let addressLine1 =
      accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''

    return (
      isFormFieldEmpty &&
      (addressLine1 === '' ||
        typeof addressLine1 === 'undefined' ||
        addressLine1 === null)
    )
  }

  isSaveChangesClicked = async () => {
    accountsAddressContainer.currentAddressFormValues = {
      ...this.AddressFormRef.current?.values,
    }
    accountsAddressContainer.isAccountAddressEmpty =
      await this.checkIfFormFieldsAreEmpty(this.AddressFormRef.current?.values)
  }

  handleSubmit = async () => {
    await this.isSaveChangesClicked()
    accountsAddressContainer.currentAddressFormValues = {
      ...this.AddressFormRef.current?.values,
    }
    this.addressFormValid = false
    this.accountPIIFormValid = false
    await this.AddressFormRef.current.handleSubmit()
    await this.AccountPIIFormRef.current.handleSubmit()
  }

  handleAddressSubmit = data => {
    this.combinedFormData = { ...this.combinedFormData, addressData: data }
    this.addressFormValid = true
  }

  handlePIISubmit = data => {
    /**
     * @note
     * On update forms accountId and addressId are not passed
     * assigning with profileResponse
     */
    const { accountId = '', addressId = '' } =
      accountsContainer?.profileResponse?.addresses?.[0] || {}
    if (
      data?.accountId === '' &&
      data?.addressId === '' &&
      accountId !== '' &&
      addressId !== ''
    ) {
      data.accountId = accountId || ''
      data.addressId = addressId || ''
    }
    this.combinedFormData = { ...this.combinedFormData, PIIData: data }
    this.accountPIIFormValid = true
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.SUBMIT_BUTTON:
        let homeCountry = storeContainer.currentRegion || ''

        customerContainer?.profileResponse?.accounts?.properties?.forEach(
          (element = {}) => {
            if (element.attributeId === 'countryCode') {
              homeCountry = element.value
            }
          }
        )

        if (homeCountry === 'CA') {
          homeCountry = 'Canada'
        }

        let hideMessage = ''
        if (!isB2B2CAdmin()) {
          hideMessage = 'd-none'
        } else {
          hideMessage =
            homeCountry === storeContainer.storeIDValue ? '' : 'd-none'
        }

        return {
          hideMessageClass: hideMessage,
          showMessageClass:
            homeCountry === storeContainer.storeIDValue
              ? 'd-none'
              : 'non-home-market-country mt-1',
          size: application.isMobile ? 'sm' : 'md',
        }

      default:
        return {}
    }
  }

  renderSubmitButton = () => {
    const data = this.getDataModal(this.SUBMIT_BUTTON)
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)

    return (
      <Row>
        <Col className={styles?.hideMessageClass}>
          <Button
            variant="primary"
            className="addressbook-add-button shipping-button justify-content-center align-items-center mt-2"
            data-testid="qa-save-changes"
            size={styles?.size}
            type="submit"
            onClick={this.handleSubmit}>
            {data?.saveChangesText}
          </Button>
        </Col>
        <div className={styles?.showMessageClass}>{data?.message}</div>
      </Row>
    )
  }

  getDataModal(dataKey) {
    switch (dataKey) {
      case this.FORM:
        const accProperties =
          accountsContainer?.profileResponse?.properties || {}
        const spid =
          !Object.keys(accProperties).length == 0 &&
          accProperties?.find(list => list.attributeId === 'sponsorId')
        const accountsData = customerContainer?.profileResponse?.accounts
        return {
          formTitle: i18nTranslate(
            'accountProfile.lglAddressTitle',
            'Account Information'
          ),
          addressData:
            (accountsData != null &&
              accountsContainer?.profileResponse?.addresses?.[0]) ||
            {},
          addressproPrpperties:
            accountsContainer?.profileResponse?.properties?.[0] || {},
          identity: customerContainer?.profileResponse || {},
          accProperties,
          sponsorId: spid?.value || '',
          accountPrefillData: this.context?.accountPrefillData || {
            accountInfo: accountsContainer?.profileResponse,
          },
          constructStyle: this.context?.constructStyle,
          accountSettings: this.context?.accountSettings,
          isSelfOnBoard: this.context?.isSelfOnBoard,
          buyerAdminMailId: this.context?.buyerAdminMailId,
        }
      case this.SUBMIT_BUTTON:
        return {
          saveChangesText: i18nTranslate(
            'accountProfile.orgAddressSaveButton',
            'Save Changes'
          ),
          message: i18nTranslate(
            'myprofile.submit.message',
            'Please switch to your home market to make any changes.'
          ),
        }
      case this.POPUP:
        return {
          modalTitle: i18nTranslate('emailUpdate', 'Email Update'),
          changeEmailMessage1: i18nTranslate(
            'changeEmailmsg1',
            "You are changing account's primary email for account correspondence and used for logging in.",
            {
              nameSpace: 'ssr-resource',
            }
          ),
          changeEmailMessage2: i18nTranslate(
            'changeEmailmsg2',
            'Are you sure you want to save changes?',
            {
              nameSpace: 'ssr-resource',
            }
          ),
          proceedText: i18nTranslate('myprofile.proceed', 'Proceed'),
        }
      default:
        return {}
    }
  }

  renderPopup = () => {
    const data = this.getDataModal(this.POPUP)

    return (
      <div>
        <Modal
          show={true}
          onHide={this.handleClosePopup}
          backdrop="static"
          keyboard={false}
          className="modal_box">
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              {data?.modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert className="loyaltyAlert" variant="danger">
              {data?.changeEmailMessage1} {data?.changeEmailMessage2}
            </Alert>
            <Button
              className="confirmButton mb-2 ml-7"
              variant="primary"
              onClick={() => this.handleSubmitPopup(this.popupFormData)}>
              {data?.proceedText}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    )
  }

  handleClosePopup = () => {
    this.showPopup = false
  }

  handleProcess = async formData => {
    // this.showPopup = false
    const formDataTemp = {
      ...formData,
    }
    let isFormFieldsAreEmpty =
      (await this.checkIfFormFieldsAreEmpty(
        accountsAddressContainer.currentAddressFormValues
      )) || false
    let formFields = await this.getFormFieldsBasedOnCountry()
    const addressData = accountsContainer?.profileResponse?.addresses?.[0] || {}

    if (
      storeContainer.storeIDValue === 'US' ||
      storeContainer.storeIDValue === 'Canada' ||
      formDataTemp.isToMakeValidationApiCall
    ) {
      const isSavedAddressSameAsEnteredAddress =
        await checkIfTwoFormValuesAreEqual(
          formFields,
          formDataTemp,
          addressData
        )
      if (
        !isSavedAddressSameAsEnteredAddress &&
        !isFormFieldsAreEmpty &&
        !this.addressDisable
      ) {
        const res = (await addressContainer.validateAddress(formDataTemp)) || {}
        const recommendationAddress =
          res?.address?.validationDetails?.[0]?.recommendations || []
        let firstAddress = recommendationAddress?.[0] || {}

        if (res?.code === 'ADCOVAL0003' || res.status === 400) {
          this.addressInvalidFlag = true
          this.recommendations = [{ ...formDataTemp }, []]
          this.formDataEnter = { ...formDataTemp }
          this.nonValidAddress = true
          this.show = true
        } else if (res?.code == 'ONESOURCE_ADPLGIN_VAL_ERROR') {
          this.setState({
            show: false,
          })
          toastState.setToastMessage(
            i18nTranslate('address.NotAdded', 'Address not added')
          )
          return
        } else if (res?.code == 'AOACHLD0001') {
          this.setState({
            show: false,
          })
          toastState.setToastMessage(
            i18nTranslate(
              'myaccount.userHoldStatus',
              'There is an issue with your account. Please contact you local account manager.'
            )
          )
          return
        } else {
          let isFirstSuggestedAddressSameAsCurrentAddress =
            checkIfTwoFormValuesAreEqual(formFields, formDataTemp, firstAddress)
          if (!isFirstSuggestedAddressSameAsCurrentAddress) {
            this.addressInvalidFlag = false
            this.recommendations = [
              { ...formDataTemp },
              ...recommendationAddress,
            ]
            this.formDataEnter = { ...formDataTemp }
            this.show = true
          } else {
            this.formDataEnter = { ...formDataTemp }
            this.handleClickOnPro(formDataTemp)
          }
        }
      } else {
        const addrress1 =
          accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''
        const valAdd = accountsContainer?.profileResponse?.addresses?.[0] || ''

        if (addrress1 === '' && valAdd === '' && !isFormFieldsAreEmpty) {
          await accountsAddressContainer.addAddress(formDataTemp)
        } else {
          const isProfileUpdated = true
          const isAddressUpdated = true
          const reqPayload = await this.filterEditData(
            formData,
            isProfileUpdated,
            isAddressUpdated
          )
        }
        await customerContainer.updateForAccountProfile(formDataTemp)
      }
    } else {
      const addrress1 =
        accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''
      const valAdd = accountsContainer?.profileResponse?.addresses?.[0] || ''
      if (addrress1 === '' && valAdd === '' && !isFormFieldsAreEmpty) {
        await accountsAddressContainer.addAddress(formDataTemp)
        await customerContainer.updateForAccountProfile(formDataTemp)
      } else if (addrress1 === '' && valAdd === '' && isFormFieldsAreEmpty) {
        const isProfileUpdated = true
        const isAddressUpdated = false
        const reqPayload = await this.filterEditData(
          formData,
          isProfileUpdated,
          isAddressUpdated
        )
        await customerContainer.updateForAccountProfile(formDataTemp)
      } else {
        this.formDataEnter = { ...formDataTemp }
        this.handleClickOnPro(formDataTemp)
      }
    }
  }

  handleCondition = (formData = {}) => {
    this.handleProcess(formData)
  }

  filterEditData = (
    formData = {},
    isProfileUpdated = true,
    isAddressUpdated = true
  ) => {
    let data = { addressId: formData?.addressId || formData?.id }
    const profileData = accountsContainer?.profileResponse?.customer || ''

    if (isProfileUpdated) {
      if (
        formData?.firstName !== profileData?.firstName &&
        formData?.firstName != ''
      ) {
        data = { ...data, firstName: formData?.firstName || '' }
      }
      if (formData?.lastName !== profileData?.lastName) {
        data = { ...data, lastName: formData?.lastName || '' }
      }
      if (formData?.email !== profileData?.email && formData?.email != '') {
        data = { ...data, email: formData?.email || '' }
      }
      if (formData?.phone !== profileData?.phoneNumber) {
        data = { ...data, phone: formData?.phone || '' }
      }
      if (
        formData?.businessEmail !== profileData?.email &&
        formData?.businessEmail != ''
      ) {
        data = { ...data, businessEmail: formData?.businessEmail || '' }
      }
    }
    if (isAddressUpdated) {
      data = {
        ...data,
        addressLine1: formData?.addressLine1 || '',
        addressLine2: formData?.addressLine2 || '',
        state: formData?.state || '',
        zip: formData?.zip || '',
        county: formData?.county || '',
        country: formData?.country || '',
        city: formData?.city || '',
        email: formData?.email || '',
        phone: formData?.phone || '',
      }
      if (formData?.businessEmail != '') {
        delete data?.email
        data = {
          ...data,
          businessEmail: formData?.businessEmail || '',
        }
      }
    }
    return data
  }

  handleProfileInformationValidation = async (params = {}) => {
    const {
      firstName = '',
      lastName = '',
      businessEmail = '',
      phone = '',
      phoneCountryCode = '',
      email = '',
    } = params
    const profileData = await accountsContainer?.profileResponse?.customer
    const phoneObj =
      (await parsePhoneNumberField(phone, phoneCountryCode)) || {}
    if (profileData !== '') {
      if (
        profileData?.firstName === firstName &&
        profileData?.lastName === lastName &&
        profileData?.email === (email || businessEmail) &&
        profileData?.phoneNumber === phoneObj?.number
      ) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  async handleClickOnPro(formData) {
    const addrress1 =
      accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''
    const valAdd = accountsContainer?.profileResponse?.addresses?.[0] || ''
    const {
      businessEmail = '',
      email = '',
      phone = '',
      phoneCountryCode = '',
    } = this.formDataEnter
    const params = {
      businessEmail,
      email,
      phone,
      phoneCountryCode: phoneCountryCode || this.formData.phoneCountryCode,
      ...formData,
    }
    const isProfileUpdated =
      await this.handleProfileInformationValidation(params)

    const showToastMessage = this.show && isProfileUpdated ? false : true

    if (addrress1 == '' && valAdd == '') {
      if (formData?.selectedIndex <= 0) {
        await accountsAddressContainer?.validateOriginalAccountAddress(
          formData,
          showToastMessage
        )
      } else {
        await accountsAddressContainer?.addAddress(formData, showToastMessage)
      }
    } else {
      const isAddressUpdated = true
      const reqPayload = this.filterEditData(
        params,
        isProfileUpdated,
        isAddressUpdated
      )
      if (formData.selectedIndex <= 0) {
        await accountsAddressContainer.validateUpdatedAddress(
          reqPayload,
          showToastMessage
        )
      } else {
        await accountsAddressContainer.updateAccountAddress(
          reqPayload,
          showToastMessage
        )
      }
    }
    // }

    this.handleClose()
    await customerContainer.updateForAccountProfile(params, isProfileUpdated)
  }

  handleClose = () => {
    this.show = false
  }

  handleSubmitPopup = (popupFormData = {}) => {
    this.showPopup = false
    this.popupFormData = {}
    this.handleCondition(popupFormData)
  }

  customHandleBlur = async ({ values = {} }) => {
    if (values?.mobilePhoneNumber !== '') {
      const phoneNumberCode = await parsePhoneNumberField(
        values?.mobilePhoneNumber,
        values?.phoneCountryCode
      )
      const isValidMobile = await validLibMobilePhoneNumber(phoneNumberCode)
      accountsContainer.phoneNumberIsValid = isValidMobile
    }
  }

  isAddressDisabled = () => {
    let homeCountry = ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          homeCountry = element.value
        }
      }
    )
    let storeIdBasedOnCountry = storeContainer.storeIDValue
    storeIdBasedOnCountry =
      storeIdBasedOnCountry.toLowerCase() === 'canada'
        ? 'CA'
        : storeIdBasedOnCountry
    let countryName = homeCountry || storeContainer.storeIDValue
    return !isB2B2CAdmin() || countryName !== storeIdBasedOnCountry
      ? true
      : false
  }

  render() {
    const data = this.getDataModal(this.FORM)
    let isAddressDisabled = this.isAddressDisabled()

    let homeCountry = storeContainer.currentRegion || ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      (element = {}) => {
        if (element?.attributeId === 'countryCode') {
          homeCountry = element?.value
        }
      }
    )
    if (homeCountry === 'CA') {
      homeCountry = 'Canada'
    }
    const isHomeCountry = homeCountry === storeContainer?.storeIDValue || false
    const addressData = accountsContainer?.profileResponse?.addresses?.[0] || ''
    const acctype = getLocalStorage('accountType') || ''
    const isAddressPlainText =
      APPConfig?.getAppConfig()?.enableAddressPlainTextNonHomeCountry ===
        'true' || false

    const accProperties = accountsContainer?.profileResponse?.properties
    const spid =
      accProperties &&
      accProperties.find(list => list.attributeId === 'sponsorId')
    const sponsorId = spid?.value || ''
    if (sponsorId !== 'RETFLOAT') {
      customerContainer?.sponsorIdValidation(sponsorId)
    }
    const upgradeClassName = isHomeCountry ? 'mt-2' : 'd-none'

    const nonHomeCountry = () => {
      return (
        <ul className="non-homecountry-address">
          <li>
            <b>{i18nTranslate('account.homeCountry', 'Home Country')}</b>
            {': '}
            {homeCountry}
          </li>
          <li>
            <b>{i18nTranslate('accountProfile.orgAddressTitle', 'Address')}</b>
            {': '}
          </li>
          {addressData?.addressLine1 && (
            <li>
              {addressData?.addressLine1}, {addressData?.addressLine2 || ''}
              <br />
              {addressData?.city}, {addressData?.state}, {addressData?.zip}
            </li>
          )}
        </ul>
      )
    }
    const isAccountAddressAlreadyExists =
      accountsContainer.profileResponse?.addresses?.length > 0 &&
      accountsContainer.profileResponse?.addresses?.[0]?.addressLine1

    return (
      <React.Fragment>
        <Card className="shadow-sm">
          <Card.Body className="bg-white">
            <Card.Title>
              <h1 className="card-title heading-2">{data?.formTitle}</h1>
            </Card.Title>
            {this.showPopup && this.renderPopup()}
            {this.show && (
              <AddressValidation
                open={this.show}
                addressInvalidFlag={this.addressInvalidFlag}
                recommendations={this.recommendations}
                handleClose={this.handleClose}
                handleClickOnPro={dataAfterValidation =>
                  this.handleClickOnPro(dataAfterValidation)
                }
              />
            )}
            <div className="required-note mx-0 mb-1 d-flex justify-content-start">
              {i18nTranslate(
                'accountProfile.requiredNote',
                'Fields marked with * are required'
              )}
            </div>
            {/*Address Form */}
            <AccountProfilePIIForm
              onSubmit={this.handlePIISubmit}
              refId={this.AccountPIIFormRef}
              data={data}
              customHandleBlur={this.customHandleBlur}
              isAddressDisabled={isAddressDisabled}
            />
            {isHomeCountry || !isAddressPlainText
              ? IS_BROWSER && (
                  <Suspense fallback={<div className="my-2">Loading...</div>}>
                    <this.AddressForm
                      onSubmit={this.handleAddressSubmit}
                      refId={this.AddressFormRef}
                      // addressInfo={data?.accountPrefillData}
                      type={'accountProfile'}
                      isToDisableAddressFields={this.addressDisable}
                      addressInfo={data?.addressData}
                      isSelfOnBoard={data?.isSelfOnBoard}
                      // addressproPrpperties={data?.addressproPrpperties}
                      isAddressDisabled={isAddressDisabled}
                    />
                  </Suspense>
                )
              : IS_BROWSER && (
                  <Suspense fallback={<div className="my-2">Loading...</div>}>
                    {nonHomeCountry()}
                  </Suspense>
                )}
            {this.renderSubmitButton(data)}
          </Card.Body>
        </Card>
        <Card className={upgradeClassName}>
          <Card.Body className="bg-white">
            <Card.Title>
              <h1 className="card-title heading-2">
                {i18nTranslate('accounts.accountTypeHeading', 'Account Type')}
              </h1>
            </Card.Title>
            {Object.keys(accountsContainer?.profileResponse || {}).length >
              0 && (
              <ChangeAccountTypeCard
                handleShowDownConvertForm={
                  this.props?.handleShowDownConvertForm
                }
                history={this.props?.history || ''}
              />
            )}
          </Card.Body>
        </Card>
      </React.Fragment>
    )
  }
}

export { AccountFormIntlShipping }
export default AccountFormIntlShipping
